import PropTypes from "prop-types"

// Helper function to get sort direction for ARIA
const getSortDirection = (sorter, field) => {
  if (!sorter || sorter.field !== field) return "none"
  return sorter.order === "ascend" ? "ascending" : "descending"
}

const getHeaders = (sorter) => [
  {
    title: "Name",
    dataIndex: "name",
    key: "name",
    sorter: true,
    width: 200,
    ellipsis: true,
    "aria-sort": getSortDirection(sorter, "sort_by_user_full_name"),
    "aria-label": "Client name, sortable"
  },
  {
    title: "Group",
    dataIndex: "group",
    key: "group",
    sorter: true,
    width: 160,
    ellipsis: true,
    "aria-sort": getSortDirection(sorter, "sort_by_groups"),
    "aria-label": "Client group, sortable"
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    width: 150,
    ellipsis: true,
    "aria-label": "Email address"
  },
  {
    title: "Phone",
    dataIndex: "phone",
    key: "phone",
    width: 120,
    ellipsis: true,
    "aria-label": "Phone number"
  },
  {
    title: "Last Experience",
    dataIndex: "last_booked_trip_title",
    key: "last_booked_trip_title",
    width: 150,
    ellipsis: true,
    "aria-label": "Last experience"
  },
  {
    title: "Experience Date",
    dataIndex: "experience_date",
    key: "experience_date",
    sorter: true,
    width: 150,
    ellipsis: true,
    align: "right",
    "aria-sort": getSortDirection(sorter, "sort_by_last_trip_date"),
    "aria-label": "Experience date, sortable"
    // defaultSortOrder: "descend" // Default sort by date descending
  },
  {
    title: "YTD Spend",
    dataIndex: "ytd_spend",
    key: "ytd_spend",
    sorter: true,
    width: 120,
    ellipsis: true,
    "aria-sort": getSortDirection(sorter, "sort_by_total_booking_amount"),
    "aria-label": "Year to date spend, sortable"
  },
  {
    title: "Actions",
    dataIndex: "actions",
    width: 60,
    align: "right",
    key: "actions",
    "aria-label": "Actions"
  }
]

getHeaders.propTypes = {
  sorter: PropTypes.object
}

export { getHeaders }
